/**
 * Internal object format for a quad tree node
 */
export class QuadTreeNode {
    constructor(x, y, zoomLevel, tilingScheme, ellipsoid, parent) {
        this.x = x;
        this.y = y;
        this.zoomLevel = zoomLevel;
        this.ellipsoid = ellipsoid;
        this.tilingScheme = tilingScheme;
        this.parent = parent;
        this._children = [];
        this.lastTouchedFrame = 0;
        // Calculate the region and bounding sphere of this node
        this.region = this.tilingScheme.tileXYToRectangle(x, y, zoomLevel);
        this.boundingSphere = this.ellipsoid.approximateBoundingSphereForRegion(this.region.southwest, this.region.northeast);
    }
    /**
     * Generate this node's children
     */
    generateChildren() {
        this._children = [];
        for (let childRelY = 0; childRelY < 2; childRelY += 1) {
            for (let childRelX = 0; childRelX < 2; childRelX += 1) {
                const childX = this.x * 2 + childRelX;
                const childY = this.y * 2 + childRelY;
                this._children.push(new QuadTreeNode(childX, childY, this.zoomLevel + 1, this.tilingScheme, this.ellipsoid, this));
            }
        }
    }
    /**
     * Get all the children of this node
     *
     * If there are no children, this will return an empty list
     */
    get children() {
        return [...this._children];
    }
}
